import { fromJS } from 'immutable';
import { message } from 'antd';

import {
  OPEN_POPUP,
  CLOSE_POPUP,
  ADD_DRAFT_WO,
  LOAD_QUOTE_SUCCESS,
  GET_CAMPAIGN_CODE_ERROR,
  EDIT_ROW,
  INFOCARD_LOADED,
  WORK_DETAILS_ERROR,
  SAVING_ROW,
  DELETE_LINE_ITEM,
  GARAGE_WORK_OPERATION_PRICES,
  GARAGE_WORK_OPERATION_PRICES_SUCCESS,
  GARAGE_WORK_OPERATION_PRICES_ERROR,
  ORIGINAL_WORK_OPERATION_PRICES_SUCCESS,
  ORIGINAL_WORK_OPERATION_PRICES_ERROR,
  APPROVE_PROPOSED_WORK_OPERATION,
  DECLINE_PROPOSED_WORK_OPERATION,
} from './constants';

export const initialState = fromJS({
  popupOpen: false,
  quote: null,
  jobInvitation: null,
  garage: null,
  editingKey: null,
  exitingKey: null,
  savingKey: null,
  deletingKey: null,
  infocards: [],
  prices: {
    list: [],
    loading: false,
  },
  originalPrices: {
    list: [],
    loading: false,
  },
  approvedProposedWorkOperations: [],
  declinedProposedWorkOperations: [],
});

export default function workDetailsReducer(state = initialState, action) {
  const isPendingInvite = () => state.getIn(['jobInvitation', 'status']) === 'pending';

  switch (action.type) {
    case OPEN_POPUP:
      return state.set('popupOpen', true);
    case CLOSE_POPUP:
      return state.set('popupOpen', false);
    case EDIT_ROW:
      if (isPendingInvite()) return state;
      return state.set('editingKey', action.editingKey);
    case INFOCARD_LOADED:
      return state.set('infocards', fromJS(action.infocards));
    case GARAGE_WORK_OPERATION_PRICES:
      return state.set(
        'prices',
        fromJS({
          list: [],
          loading: true,
        })
      );
    case GARAGE_WORK_OPERATION_PRICES_SUCCESS:
      return state.set(
        'prices',
        fromJS({
          list: action.prices,
          loading: true,
        })
      );
    case GARAGE_WORK_OPERATION_PRICES_ERROR:
      return state.set(
        'originalPrices',
        fromJS({
          list: [],
          loading: true,
        })
      );
    case ORIGINAL_WORK_OPERATION_PRICES_SUCCESS:
      return state.set(
        'originalPrices',
        fromJS({
          list: action.prices,
          loading: true,
        })
      );
    case ORIGINAL_WORK_OPERATION_PRICES_ERROR:
      return state.set(
        'originalPrices',
        fromJS({
          list: [],
          loading: true,
        })
      );
    case LOAD_QUOTE_SUCCESS:
      return state.merge({
        editingKey: null,
        savingKey: null,
        deletingKey: null,
        quote: fromJS(action.quote),
        jobInvitation: fromJS(action.invite),
        garage: fromJS(action.garage),
      });
    case GET_CAMPAIGN_CODE_ERROR:
      message.error(action.message);
      return state;
    case WORK_DETAILS_ERROR:
      message.error(action.message);
      return state.set('savingKey', null).set('deletingKey', null);
    case ADD_DRAFT_WO:
      if (isPendingInvite()) return state;
      return state
        .set('editingKey', null)
        .updateIn(['quote', 'lineItems'], (dts) =>
          dts.filter((l) => l.get('operationId')).push(fromJS(action.payload))
        );
    case DELETE_LINE_ITEM:
      return state.set('deletingKey', action.operationId);
    case SAVING_ROW:
      return state.set('savingKey', action.savingKey);
    case APPROVE_PROPOSED_WORK_OPERATION:
      return state
        .set(
          'approvedProposedWorkOperations',
          fromJS([
            ...state
              .get('approvedProposedWorkOperations')
              .filter((i) => i !== action.workOperation.operationId),
            action.workOperation.operationId,
          ])
        )
        .set(
          'declinedProposedWorkOperations',
          fromJS([
            ...state
              .get('declinedProposedWorkOperations')
              .filter((i) => i !== action.workOperation.operationId),
          ])
        );
    case DECLINE_PROPOSED_WORK_OPERATION:
      return state
        .set(
          'declinedProposedWorkOperations',
          fromJS([
            ...state
              .get('declinedProposedWorkOperations')
              .filter((i) => i !== action.workOperation.operationId),
            action.workOperation.operationId,
          ])
        )
        .set(
          'approvedProposedWorkOperations',
          fromJS([
            ...state
              .get('approvedProposedWorkOperations')
              .filter((i) => i !== action.workOperation.operationId),
          ])
        );
    default:
      return state;
  }
}
